import React from 'react';
import { Card } from 'primereact/card';
import { useLanguage } from '../../../contexts/LanguageContext';
import useVehicleDetail from './hooks/useVehicleDetail';
import VehicleSearchForm from './components/VehicleSearchForm';
import VehicleAccordionTabs from './components/VehicleAccordionTabs';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';

const VehicleDetailPage = () => {
    const { th } = useLanguage();
    const { toast, formProps, resultProps} = useVehicleDetail();
    const vehicleInfo = resultProps.data?.vehicleInformation;
    const chassisNo = vehicleInfo?.sasiNo;
    const languageCode = vehicleInfo?.zlangu;
  
    return (
        <div className="card p-4">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleDetailInformation.title')}</h1>
            </div>

            <VehicleSearchForm {...formProps} />
           {
    (
        resultProps.data?.vehicleInformation ||
        resultProps.data?.vehicleComplianceInformation ||
        resultProps.data?.vehicleLocationInformation ||
        resultProps.data?.vehicleOrderInvoiceInformation ||
        resultProps.data?.configurationInfo
    ) && (
        <div className="mt-3">
          
    {resultProps.hasPdf === true && (
       
        <Button
            label={th('vehicleDetailInformation.viewComplianceDoc')}
            icon="pi pi-file-pdf"
            severity="danger"
            outlined
            onClick={() =>
               
                resultProps.onDownloadPdf(chassisNo, languageCode)
            }
        />
    )}

    {resultProps.hasPdf === false && (
        <Message
            severity="warn"
            text={th('vehicleDetailInformation.noComplianceDoc')}
        />
    )}
</div>

    )
}

            {resultProps.data && <VehicleAccordionTabs data={resultProps.data} />}
        </div>
    );
};

export default VehicleDetailPage;
